export default __webpack_public_path__ + "static/media/ct213-6.054a250d.png";